module.exports = __webpack_public_path__ + "img/Ekivolt.dd2d6232.png";